module.exports = __webpack_public_path__ + "static/media/icon-person-tick.f776364f.svg";